import { FC, useEffect } from "react";
import { ServerEventListenerCubit } from "src/state/ServerEventListener/ServerEventListenerCubit";
import { useBloc } from "@blac/react";
import { useNavigate } from "react-router-dom";

interface ServerMessageHandlerProps {
  cubit: ServerEventListenerCubit;
}

/**
 * This component is a control component for server event listener cubits.
 * The main purpose is to bind the operation of the cubit instance to a React
 * component's lifecycle.
 * E.g.: Listen to certain server events only when a specific page was displayed.
 *
 * This component should not render anything.
 *
 * @constructor
 */
export const ServerMessageHandler: FC<ServerMessageHandlerProps> = ({
  cubit
}) => {
  const navigate = useNavigate();

  const [, instance] = useBloc(cubit);
  useEffect(() => {
    instance.activate(navigate);

    return () => instance.deactivate();
  }, [instance, navigate]);

  return null;
};
